import React, { useEffect, useState } from "react";
import { useRouter } from "./../util/router";
import { useSite } from "../util/sites";
import DashboardContents from "./../components/dashboard/DashboardContents";
import LoaderGraph from "../components/general/LoaderGraph";
import { useUser } from "../util/user";

function DashboardPage(props) {
	const router = useRouter();
	const currentSite = useSite();
	const [hasAccess, setHasAccess] = useState(false);
	const [route, setRoute] = useState(props.route);
	const [siteID, setSiteID] = useState(null);
	const KCuser = useUser();

	// Set state if props changes
	useEffect(() => {
		if (route != props.route) setRoute(props.route);
	}, [props.route]);

	useEffect(() => {
		const siteID_SS =
			sessionStorage.getItem("site_id") != null
				? sessionStorage.getItem("site_id")
				: null;
		const site_id =
			route.match.params.site_id != null
				? parseInt(route.match.params.site_id)
				: siteID_SS;
		const userObj = KCuser;

		// User is authenticated
		if (userObj != null) {
			// User has access to the page
			if (userObj.roles != null && userObj.roles.includes("dashboard:_view")) {
				const authorisedSites = currentSite.authorisedSites;

				// User has access to site
				if (
					site_id != null &&
					authorisedSites != null &&
					authorisedSites.includes(site_id)
				) {
					currentSite.changeSite(site_id);
					sessionStorage.setItem("site_id", site_id);
					setHasAccess(true);
					setSiteID(site_id);
				}
			}
		} else {
			router.replace("/solar/logout");
		}

		return () => {
			setSiteID(null);
			setHasAccess(false);
		};
	}, [KCuser, route, currentSite.authorisedSites]);

	return (
		<>
			{hasAccess ? (
				<DashboardContents siteID={siteID} />
			) : (
				<LoaderGraph style={{ height: "89vh" }} />
			)}
		</>
	);
}

export default DashboardPage;
